import React, { useState, useEffect } from 'react';
import { getArticles} from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

const Articles = () => {
  const { t } = useTranslation('global');

  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchArticles = async() =>{
    const response = await getArticles();
    console.log(response);
    setArticles(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.name"), accessor: 'name' },
    { Header: t("list.unit_of_measure_id"), accessor: 'unit_of_measure_id' },
    { Header: t("list.num_portion"), accessor: 'num_portion' },
    { Header: t("list.unit_price"), accessor: 'unit_price' },
    { Header: t("list.active"), accessor: 'active' },
    { Header: t("list.button"), accessor:'button'}

  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth>
      <DataTable initialData={articles} columns={columns} entityName="articles" h2={t("list.articles")} />
    </Container>
  );
};

export default Articles;
